import React from 'react';
import { useTheme } from 'styled-components';
import { QuizTimer } from '@skooldio/skooldio-classroom-components';
import { useMediaQuery } from '@material-ui/core';

import { Box, Flex, Text, SvgIcon } from 'Components/Base';
import { QUIZ_VARIANTS, EXAM_PAPER_ITEM_TYPE } from 'Components/Quiz/constant';
import { SESSION_STATUS } from 'Context/AssessmentContext';
import { useConfig } from 'Context/ConfigContext';
import { useOffset } from 'Context/LayoutContext/OffsetProvider';
import { useScrollIndicator } from 'Util/Hooks';
import ScrollSeeMoreWrapper from 'Components/ScrollSeeMoreWrapper';

import QuizQuestion from '../QuizQuestion';

import QuizContentWrapper from './QuizContentWrapper';
import QuizDivider from './QuizDivider';
import QuizLayoutWrapper from './QuizLayoutWrapper';
import QuizFooterWrapper from './QuizFooterWrapper';
import { ActionBox, QuizInnerLayout, QuizPaperItem } from './QuizBox.view';

const QuizBoxWithPassageView = ({
  choices,
  currentQuestionText,
  isFirstQuestion,
  isLastQuestion,
  isSubmitting,
  onBack,
  onNext,
  precisionNumber,
  question,
  questionId,
  questionNo,
  questionType = EXAM_PAPER_ITEM_TYPE.MULTIPLE_CHOICE,
  renderChoice,
  status,
  timeRemaining,
  variant,
  passage,
}) => {
  const {
    classroom: { quiz },
  } = useConfig();
  const { colors, breakpoints } = useTheme();
  const { bottomOffset } = useOffset();
  const isDesktop = useMediaQuery(`(min-width:${breakpoints?.lg ?? '1024px'})`);
  const { showAnswersConfirmation = false } = quiz?.gradedExam ?? {};
  const isTimeout = status === SESSION_STATUS.TIMEOUT || status === SESSION_STATUS.READY_TO_GRADE;
  const latexTranspiler = quiz?.latexTranspiler;

  const Wrapper = isDesktop ? QuizContentWrapper : Box;

  const { showIndicator, wrapperRef, onScroll } = useScrollIndicator();

  return (
    <QuizInnerLayout>
      <Text fontFamily="contentReadable">
        {variant === QUIZ_VARIANTS.GRADED_EXAM && (
          <Flex justifyContent="space-between" pt={6}>
            <Text color="greyscale.grey3" fontFamily="contentReadable">
              {currentQuestionText}
            </Text>
            <QuizTimer
              color={isTimeout ? colors.danger : colors.primary}
              isTimeout={isTimeout}
              timeRemaining={timeRemaining}
            />
          </Flex>
        )}
        <QuizLayoutWrapper isDesktop={isDesktop}>
          <ScrollSeeMoreWrapper isShowScrollDown={showIndicator}>
            <QuizContentWrapper
              ref={wrapperRef}
              onScroll={onScroll}
              height={isDesktop ? '80vh' : '28vh'}
            >
              <QuizQuestion
                question={passage}
                questionNo={questionNo && `${questionNo}.`}
                pt={4}
                pb={8}
                mb={0}
                loadingComponent={() => (
                  <SvgIcon color="primary" icon={SvgIcon.ICON_LIST.LOADING} />
                )}
                variant={latexTranspiler}
              />
            </QuizContentWrapper>
          </ScrollSeeMoreWrapper>
          <QuizDivider isDesktop={isDesktop} />
          <Wrapper height={isDesktop ? '80vh' : '100%'} pb={isDesktop ? 8 : 0} pr={2}>
            <QuizQuestion
              question={question}
              questionNo={questionNo && `${questionNo}.`}
              pt={4}
              loadingComponent={() => <SvgIcon color="primary" icon={SvgIcon.ICON_LIST.LOADING} />}
              variant={latexTranspiler}
            />
            <QuizPaperItem
              questionType={questionType}
              variant={variant}
              choices={choices}
              questionId={questionId}
              renderChoice={renderChoice}
              labelVariant={latexTranspiler}
              precisionNumber={precisionNumber}
            />
          </Wrapper>
        </QuizLayoutWrapper>
      </Text>
      <QuizFooterWrapper bottomOffset={bottomOffset}>
        <ActionBox
          variant={variant}
          onNext={onNext}
          onBack={onBack}
          isLastQuestion={isLastQuestion}
          isFirstQuestion={isFirstQuestion}
          style={{ height: '100%' }}
          isSubmitting={isSubmitting}
          nextButtonText={
            isLastQuestion && variant === QUIZ_VARIANTS.GRADED_EXAM && !showAnswersConfirmation
              ? 'ส่งคำตอบ'
              : undefined
          }
        />
      </QuizFooterWrapper>
    </QuizInnerLayout>
  );
};

export default QuizBoxWithPassageView;
